import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import VigorbuySpreadsheetGuide from "@/pages/vigorbuy-spreadsheet-guide/page";
import VigorbuySpreadsheetTemplates from "@/pages/vigorbuy-spreadsheet-templates/page";
import VigorbuySpreadsheetComparisons from "@/pages/vigorbuy-spreadsheet-comparisons/page";
import VigorbuySpreadsheetSecurity from "@/pages/vigorbuy-spreadsheet-security/page";
import BlogArticlePage from "@/pages/blog/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <VigorbuySpreadsheetGuide />,
  },
  {
    path: "/vigorbuy-spreadsheet-templates",
    element: <VigorbuySpreadsheetTemplates />,
  },
  {
    path: "/vigorbuy-spreadsheet-comparisons",
    element: <VigorbuySpreadsheetComparisons />,
  },
  {
    path: "/vigorbuy-spreadsheet-security",
    element: <VigorbuySpreadsheetSecurity />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;